<template>
    <main class="visit-page">
        <section class="visit-shell">
            <app-header :isHaedingHide="false" @show-drawer="showDrawer"  @logout="logout"
                heading="View dealer and market visit details and review the visit information."
                subHeading="Record dealer and market visit details before submitting your report."
                btnHeading="Create Visit" :isFormPage="true" />
            <!-- <header class="visit-header">
                <q-btn flat dense rounded @click="showDrawer">
                    <div class="brand-mark"><q-icon name="menu" :size="$q.screen.lt.md ? '40px' : '28px'" /></div>
                </q-btn>
                <div class="heading-section">
                    <img class="brand-logo-sera" src="../../assets/SERA_LOGO.png" />
                    <h1>Primary Market Visit</h1>
                    <p v-if="accessType === 'readOnly'" class="header-copy">View dealer and market visit details and review the visit information.</p>
                    <p v-else class="header-copy sub-heading">Record dealer and market visit details before submitting your report.</p>
                </div>

                <div class="header-actions">
                    <q-btn flat dense no-caps :size="$q.screen.lt.md ? 'lg' : 'md'" icon="logout" label="" class="logout-link" @click="logout" />
                </div>
            </header> -->
            <div  v-if="userHaveRights"> 
            <div v-if="accessType !== 'readOnly'" class="progress-steps">
                <div v-for="(item, index) in steps" :key="index" class="progress-step"
                    :class="{ active: activeStep >= index, current: activeStep === index }">
                    <span>{{ index + 1 }}</span><small>{{ item }}</small>
                </div>
            </div>
            <q-form ref="visitForm" @submit.prevent="nextStep">
                <section v-if="activeStep === 0" class="form-card">
                    <div class="section-heading">
                        <span class="section-icon"><q-icon size="md" name="event_note" /></span>
                        <div style="display: flex; flex-direction: column; justify-content: center">
                            <h2 class="no-padding no-margin">Visit details</h2>
                            <p class="no-padding no-margin">Core information for this market visit.</p>
                        </div>
                    </div>
                    <div class="form-grid">
                        <q-input v-model.trim="form.visitId" :disable="true" outlined dense label="Visit ID *"
                            :rules="[required]" class="formField" hide-bottom-space />
                        <q-input v-model="form.visitDate" :disable="accessType === 'readOnly'" outlined dense
                            label="Visit Date *" hide-bottom-space class="formField" type="date" stack-label
                            :rules="[required]" />
                        <!-- <q-input v-model.trim="form.samName" outlined dense label="SAM Name *" :rules="[required]" /> -->
                        <template v-if="$q.screen.gt.md">
                            <custom-select :value="form.samName" model="samName"
                                :options="samNames?.map((e) => e.samName)" :key="samNames?.length" outlined dense
                                label="Sales Account Manager *" :rules="[required]" @change="handleSelect"
                                :disable="accessType === 'readOnly'" class="formField" ref="samNameSelect" />
                        </template>
                        <advance-search-select v-else :value="form.samName" model="samName"
                            :options="samNames?.map((e) => e.samName)" :key="samNames?.length" outlined dense
                            label="Sales Account Manager *" :rules="[required]" @change="handleSelect"
                            :disable="accessType === 'readOnly'" class="formField" />
                        <template v-if="$q.screen.gt.md">
                            <custom-select :value="form.visitPurpose" model="visitPurpose"
                                :options="visitPurposes.map((e) => e.visitPurposeName)" outlined dense
                                :key="visitPurposes?.length" label="Visit Purpose *" @change="handleSelect"
                                :disable="accessType === 'readOnly'" :rules="[required]" class="formField" />
                        </template>
                        <advance-search-select v-else :value="form.visitPurpose" model="visitPurpose"
                            :options="visitPurposes.map((e) => e.visitPurposeName)" outlined dense
                            :key="visitPurposes?.length" label="Visit Purpose *" @change="handleSelect"
                            :disable="accessType === 'readOnly'" :rules="[required]" class="formField" />
                        <template v-if="$q.screen.gt.md">
                            <custom-select :value="form.region" model="region"
                                :options="regions.map((e) => e.regionName)" :key="regions?.length" outlined
                                @change="handleSelect" dense label="Region *" :rules="[required]" class="formField"
                                :disable="accessType === 'readOnly'" />
                        </template>
                        <advance-search-select v-else :value="form.region" model="region"
                            :options="regions.map((e) => e.regionName)" :key="regions?.length" outlined
                            @change="handleSelect" dense label="Region *" :rules="[required]" class="formField"
                            :disable="accessType === 'readOnly'" />
                        <template v-if="$q.screen.gt.md">
                            <custom-select :value="form.zone" model="zone" :options="zones.map((e) => e.zoneName)"
                                @change="handleSelect" :key="zones?.length" outlined dense label="Zone *"
                                :rules="[required]" class="formField" :disable="accessType === 'readOnly'" />
                        </template>
                        <advance-search-select v-else :value="form.zone" model="zone"
                            :options="zones.map((e) => e.zoneName)" @change="handleSelect" :key="zones?.length" outlined
                            dense label="Zone *" :rules="[required]" class="formField"
                            :disable="accessType === 'readOnly'" />
                        <template v-if="$q.screen.gt.md">
                            <custom-select :value="form.city" model="city" :key="cities?.length"
                                :options="cities.map((e) => e.cityName)" @change="handleSelect" outlined dense
                                label="City *" :rules="[required]" class="formField"
                                :disable="accessType === 'readOnly'" />
                        </template>
                        <advance-search-select v-else :value="form.city" model="city" :key="cities?.length"
                            :options="cities.map((e) => e.cityName)" @change="handleSelect" outlined dense
                            label="City *" :rules="[required]" class="formField" :disable="accessType === 'readOnly'" />
                    </div>
                    <div class="row q-pt-md">
                        <q-input v-model.trim="form.marketCatchment" :disable="accessType === 'readOnly'" outlined dense
                            type="textarea" class="col-12" label="Market / Catchment *" :rules="[required]" />
                    </div>
                </section>
                <section v-if="activeStep === 1" class="form-card">
                    <div class="section-heading">
                        <span class="section-icon"><q-icon name="business" /></span>
                        <div>
                            <h2>Account & contact</h2>
                            <p>Identify the account and the person met during the visit.</p>
                        </div>
                    </div>
                    <div class="form-grid">
                        <template v-if="$q.screen.gt.md">
                            <custom-select :value="form.accountCode" model="accountCode"
                                :options="accounsts.map((e) => e.id + '-' + e.accountName)"
                                :key="accounsts?.length" @change="handleSelect" outlined dense label="Account Code *"
                                :rules="[required]" no-error-icon class="formField"
                                :disable="!form.accountCode && form.dealerName ? true : false" hide-bottom-space />
                        </template>
                        <advance-search-select v-else :value="form.accountCode" model="accountCode"
                            :options="accounsts.map((e) => e.id + '-' + e.accountName)" :key="accounsts?.length"
                            @change="handleSelect" outlined dense label="Account Code *" :rules="[required]"
                            no-error-icon class="formField"
                            :disable="!form.accountCode && form.dealerName ? true : false" hide-bottom-space />

                        <!-- <q-input v-model.trim="form.accountCode" outlined dense label="Account Code" hint="ERP / CRM account code" /> -->
                        <q-input v-model.trim="form.dealerName" outlined dense label="Account / Dealer Name *"
                            :rules="[required]" class="formField" :disable="form.accountCode ? true : false" />
                        <template v-if="$q.screen.gt.md">
                            <custom-select :value="form.accountType" model="accountType"
                                :options="accountTypes.map((e) => e.accountTypeName)" @change="handleSelect" outlined
                                dense :key="accountTypes?.length" label="Account Type *"
                                :rules="form.accountCode ? [] : [required]" class="formField"
                                :disable="form.accountCode ? true : false" />
                        </template>
                        <advance-search-select v-else :value="form.accountType" model="accountType"
                            :options="accountTypes.map((e) => e.accountTypeName)" @change="handleSelect" outlined dense
                            :key="accountTypes?.length" label="Account Type *"
                            :rules="form.accountCode ? [] : [required]" class="formField"
                            :disable="form.accountCode ? true : false" />

                        <q-input v-model.trim="form.contactPerson" class="formField" outlined dense
                            label="Contact Person" :disable="form.accountCode ? true : false" /><q-input
                            v-model.trim="form.contactRole" outlined dense label="Contact Role" class="formField"
                            :disable="form.accountCode ? true : false" />
                        <q-input v-model="form.mobile" mask="####-#######" outlined dense label="Mobile Number"
                            :rules="[required]" hide-hint hide-bottom-space class="formField"
                            :disable="form.accountCode ? true : false" />
                        <q-input v-model="form.address" outlined dense label="Address" :rules="[required]" hide-hint
                            hide-bottom-space class="formField" :disable="false" />

                        <div v-if="accessType === 'readOnly' ? false : true" class="gps-field">
                            <q-input v-model.trim="form.gpsLocation" outlined dense label="GPS / Location Ref"
                                class="gps-input formField" />

                            <q-btn dense no-caps unelevated label="Map" class="gps-map-btn primary-button formField"
                                @click="handleShowDialog" />
                        </div>
                        <q-input v-model.trim="form.evidencePhoto" color="primary" outlined dense multiple
                            hint="Photo URL or reference" type="file" @change="handleImagesUploading"
                            v-if="accessType === 'readOnly' ? false : true" class="formField" />
                        <!-- <div class="q-ma-sm bordered imagesSection" style="margin-top: -10px">
                            <q-chip v-for="(file, i) in fileList" :key="i" square>
                                <q-avatar icon="delete" color="red" text-color="white" />
                                {{ file.fileObj?.name || file.fileObj?.evidencePhotoRefName }}
                            </q-chip>
                        </div> -->
                    </div>
                    <div v-if="fileList?.length"
                        class="bordered imagesSection q-mt-lg q-card--bordered q-pa-sm rounded-borders q-mb-md">
                        <div class="section-heading">
                            <span style="font-weight: 900">Attachments:</span>
                        </div>
                        <q-chip style="cursor: pointer" v-for="(file, i) in fileList" :key="i" square>
                            <q-avatar @click="deleteHandle(i)" :icon="accessType == 'readOnly' ? 'link' : 'delete'"
                                color="primary" text-color="white" />
                            <q-item-label dense @click="viewAttechment(file)">
                                {{ file.fileObj?.name || file.fileObj?.fileName }}
                            </q-item-label>
                        </q-chip>
                    </div>

                    <q-card-section v-if="mapUrl" class="shadow-2 q-pa-none" style="height: 150px">
                        <iframe :src="mapUrl" width="100%" height="100%" style="border: 0" allowfullscreen
                            loading="lazy"></iframe>
                    </q-card-section>
                </section>
                <section v-if="activeStep === 2" class="form-card review-card">
                    <div class="section-heading">
                        <span class="section-icon"><q-icon size="md" name="fact_check" /></span>
                        <div>
                            <h2>{{ accessType === 'readOnly' ? 'Visit Information' : 'Review visit' }}</h2>
                            <p v-if="accessType !== 'readOnly'">Confirm the information before submitting it.</p>
                        </div>
                    </div>
                    <div class="review-summary">
                        <div v-for="(item, i) in summary" :key="i" class="review-item">
                            <span>{{ item.label }}</span><strong>{{ item.value || '--' }}</strong>
                        </div>
                    </div>
                    <div v-if="accessType === 'readOnly'"
                        class="bordered imagesSection q-mt-lg q-card--bordered q-pa-sm rounded-borders">
                        <div class="section-heading">
                            <span style="font-weight: 900">Attachments:</span>
                        </div>
                        <template v-if="fileList?.length">
                            <q-chip v-for="(file, i) in fileList" :key="i" square>
                                <q-avatar icon="link" color="primary" text-color="white" />
                                <q-item-label style="cursor: pointer" dense @click="viewAttechment(file)">
                                    {{ file.fileObj?.name || file.fileObj?.fileName }}
                                </q-item-label>
                            </q-chip>
                        </template>
                        <span v-else>No Data Found</span>
                    </div>

                    <q-card-section class="q-mt-lg shadow-2 q-pa-none" style="height: 150px">
                        <iframe v-if="mapUrl" :src="mapUrl" width="100%" height="100%" style="border: 0" allowfullscreen
                            loading="lazy"></iframe>
                        <span v-else class="small q-ma-sm"> GPS Location Not Found! </span>
                    </q-card-section>
                    <q-banner v-if="accessType !== 'readOnly'" rounded class="review-note"><template
                            v-slot:avatar><q-icon name="info" color="primary" /></template>Once submitted, this visit
                        becomes available
                        for
                        follow-up and reporting.</q-banner>
                </section>
                <footer :class="$q.screen.lt.sm ? 'form-actions-mobile' : 'form-actions'">
                    <q-btn v-if="activeStep > 0 && accessType != 'readOnly'" flat no-caps label="Back" icon="arrow_back"
                        @click="backStep" /><q-space />
                    <!-- <q-btn
                        flat
                        no-caps
                        label="Save as draft"
                        icon="save"
                        class="draft-button"
                        @click="saveDraft"
                    /> -->
                    <div v-if="accessType != 'readOnly'">
                        <q-btn v-if="activeStep < 2" unelevated no-caps label="Continue" icon-right="arrow_forward"
                            :class="$q.screen.lt.sm ? 'primary-button-mobile' : 'primary-button'" :disable="isSaving"
                            @click="nextStep" /><q-btn v-else unelevated :disable="isSaving" :loading="isSaving" no-caps
                            label="Submit visit" icon-right="check_circle"
                            :class="$q.screen.lt.sm ? 'primary-button-mobile' : 'primary-button'"
                            :style="{ width: $q.screen.lt.sm ? '100% !important' : '' }" @click="Save" />
                    </div>
                </footer>
            </q-form>
            <edit-count-down :created-when="form.createdWhen" :server-date="form.serverDate" :limit-hours="72"
                @expired="handleExpire" v-if="accessType != 'CREATE'" />
        <location-picker :isShowLocPick="isShowLocPick" ref="locDialogRef" v-model="selectedLocation"
            @selected="locationSelected" />
            </div><access-not-allowed v-else />
        </section>
        <drawer ref="refDrawer" />
        
    </main>
</template>

<script>
    import apis from '@/utilities';
    import LocationPicker from '@/views/components/LocationPicker.vue';
    import Drawer from '../layout/drawer.vue';
    import axios from 'axios';
    import editCountDown from '../components/editCountDown.vue';
    import appHeader from '@/views/components/header.vue';
    import privileges from '@/mixins/privileges.js';
    const emptyForm = () => ({
        visitId: '',
        visitDate: new Date().toISOString().slice(0, 10),
        samName: '',
        visitPurpose: '',
        region: '',
        zone: '',
        city: '',
        marketCatchment: '',
        accountCode: '',
        dealerName: '',
        accountType: '',
        contactPerson: '',
        contactRole: '',
        mobile: '',
        gpsLocation: '',
        evidencePhoto: '',
        address: '',
        editLocked: false,
        createdWhen: '',
        serverDate: '',
        srNo:0
    });
    export default {
        name: 'VisitedForm',
        mixins: [privileges],
        components: {
            LocationPicker,
            drawer: Drawer,
            editCountDown,
            appHeader,
        },
        data() {
            return {
                activeStep: 0,
                steps: ['Visit details', 'Account & contact', 'Review'],
                form: emptyForm(),
                visitPurposes: [],
                accountTypes: [],
                selectedLocation: {
                    lat: null,
                    lng: null,
                    address: '',
                },
                isShowLocPick: false,
                samNames: [],
                cities: [],
                regions: [],
                zones: [],
                fileList: [],
                isFileUploading: false,
                isSaving: false,
                location: {},
                mapUrl: null,
                accounsts: [],
                accessType: '',
                isloading: false,
                keySelect: 0,
                remainingTime: '', // e.g. "09:58:32"
                remainingSeconds: 0,
                editExpired: false,
                timerInterval: null,
            };
        },
        beforeDestroy() {
            if (this.timerInterval) clearInterval(this.timerInterval);
        },
        computed: {
            summary() {
                return [
                    { label: 'Visit ID', value: this.form.visitId },
                    { label: 'Visit date', value: this.form.visitDate },
                    { label: 'Sales Account Manager', value: this.form.samName },
                    { label: 'Purpose', value: this.form.visitPurpose },
                    { label: 'Region', value: this.form.region },
                    { label: 'Zone', value: this.form.zone },
                    { label: 'Location', value: this.form.city },
                    { label: 'Market Catchment', value: this.form.marketCatchment },
                    { label: 'Account / dealer', value: this.form.dealerName || this.form.accountCode},
                    { label: 'Account type', value: this.form.accountType },
                    { label: 'Contact Person', value: this.form.contactPerson || this.form.mobile },
                    { label: 'Mobile', value: this.form.mobile },
                    { label: 'Contact Role', value: this.form.contactRole },
                ];
            },
            url() {
                return this.$store.getters.url;
            },
        },
        mounted() {
            this.activeStep = 0;
            const { key } = this.$route.params;
            let paramData = key.split('_');
            this.accessType = paramData[paramData.length - 1];
            this.cacheUserPrivileges();

            const draftId = this.$route.query.draft;

            if (!draftId) return;
            try {
                const drafts = JSON.parse(localStorage.getItem('sera-visit-drafts') || '[]');
                const draft = drafts.find((item) => item.id === draftId);
                if (draft) this.form = { ...this.form, ...draft.data };
            } catch (error) {
                console.log('error: ', error);
            }
        },
        methods: {
            callInitialFunctions() {
                const { key } = this.$route.params;
                let paramData = key.split('_');
                Promise.all([
                    this.getCity(),
                    this.GetZone(),
                    this.GetRegion(),
                    this.GetVisitPurpose(),
                    this.GetAccountType(),
                    this.GetSalesAccountManagers(),
                    this.GetAccounts(),
                ]).then(() => {
                    if (this.accessType != 'CREATE') {
                        this.getVisistFormById(paramData[0]);
                    }
                });
            },
            handleExpire() {
                this.form.editLocked = true;
                this.accessType = 'readOnly';
                this.activeStep = 2;
            },
            startEditCountdown(visit) {
                console.log('visit: ', visit);
                // purana interval clear kar do agar chal raha ho
                if (this.timerInterval) clearInterval(this.timerInterval);

                const serverDate = visit.serverDate;
                const submittedAt = new Date(visit.createdAt).getTime();
                const serverNow = new Date(serverDate).getTime();

                // server aur local clock ka farq nikal ke lock kar lo,
                // taake setInterval local clock se hi aage chalta rahy
                const offset = serverNow - Date.now();

                const LIMIT_MS = 24 * 60 * 60 * 1000; // 24 hours

                const tick = () => {
                    const now = Date.now() + offset;
                    const remainingMs = LIMIT_MS - (now - submittedAt);

                    if (remainingMs <= 0) {
                        this.remainingSeconds = 0;
                        this.remainingTime = '00:00:00';
                        this.editExpired = true;
                        clearInterval(this.timerInterval);
                        return;
                    }

                    this.editExpired = false;
                    this.remainingSeconds = Math.floor(remainingMs / 1000);

                    const hrs = Math.floor(remainingMs / (1000 * 60 * 60));
                    const mins = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
                    const secs = Math.floor((remainingMs % (1000 * 60)) / 1000);

                    this.remainingTime = [hrs, mins, secs].map((v) => String(v).padStart(2, '0')).join(':');
                };

                tick(); // turant ek dafa chala do, warna 1 sec wait karna paray ga
                this.timerInterval = setInterval(tick, 1000);
            },
            handleSelect(model, value) {
                this.form[model] = value;

                if (model === 'accountCode') {
                    // if (!value) return;

                    const findAcc = this.accounsts.find((e) => e.id === value?.split('-')[0]);
                    const findAccType = this.accountTypes.find((e) => e.accountTypeId === findAcc?.accountTypeId);
                    this.form.accountType = findAccType?.accountTypeName;
                    this.form.contactPerson = findAcc?.contactPerson;
                    this.form.mobile = findAcc?.phone;
                    this.form.dealerName = findAcc?.accountName || '';
                }
            },
            locationSelected(location) {
                if (!location.lat || !location.lng) return;

                this.form.gpsLocation = location.address;
                this.location = location;
                this.mapUrl = `https://www.google.com/maps?q=${location.lat},${location.lng}&output=embed`;

                /*
            Example:
    
            {
              lat: 24.860734,
              lng: 67.001136,
              address: "Karachi, Sindh, Pakistan..."
            }
          */

                // API ko send kar sakte ho
                // this.form.latitude = location.lat;
                // this.form.longitude = location.lng;
                // this.form.address = location.address;
            },
            handleShowDialog() {
                if (this.$refs.locDialogRef) {
                    this.$refs.locDialogRef?.showDialog();
                }
            },
            logout() {
                sessionStorage.setItem('token', null);
                this.$store.commit('logOutHandler');
                // this.$router.push('/login');
            },
            required(value) {
                return !!value || 'This field is required';
            },
            async nextStep() {
                const valid = await this.$refs.visitForm.validate();
                if (valid) this.activeStep = Math.min(this.activeStep + 1, 2);
            },
            saveDraft() {
                const draftId = this.$route.query.draft || `draft-${Date.now()}`;
                const drafts = JSON.parse(localStorage.getItem('sera-visit-drafts') || '[]');
                const draft = { id: draftId, data: { ...this.form }, updatedAt: new Date().toISOString() };
                const index = drafts.findIndex((item) => item.id === draftId);
                if (index >= 0) drafts.splice(index, 1, draft);
                else drafts.unshift(draft);
                localStorage.setItem('sera-visit-drafts', JSON.stringify(drafts));
                if (!this.$route.query.draft) this.$router.replace({ path: '/visit-form', query: { draft: draftId } });
                this.$q.notify({ type: 'positive', message: 'Visit saved as draft.', position: 'top' });
            },
            async submitVisit() {
                const valid = await this.$refs.visitForm.validate();
                if (!valid) {
                    this.activeStep = 0;
                    return;
                }
                const draftId = this.$route.query.draft;
                if (draftId) {
                    const drafts = JSON.parse(localStorage.getItem('sera-visit-drafts') || '[]').filter((item) => item.id !== draftId);
                    localStorage.setItem('sera-visit-drafts', JSON.stringify(drafts));
                }
                this.$q.notify({ type: 'positive', message: 'Visit submitted successfully.', position: 'top' });
                this.form = emptyForm();
                this.$router.replace('/visit-form');
                this.activeStep = 0;
                this.$refs.visitForm.resetValidation();
            },

            async getCity() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetCity}`);
                    this.cities = response.data.data ?? [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
            },
            async GetZone() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetZone}`);
                    this.zones = response.data.data ?? [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
            },
            async GetRegion() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetRegion}`);
                    this.regions = response.data.data ?? [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
            },
            async GetVisitPurpose() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetVisitPurpose}`);
                    this.visitPurposes = response.data.data ?? [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
            },
            async GetAccountType() {
                try {
                    const reponse = await axios.get(`${this.url}/${apis.GetAccountType}`);
                    this.accountTypes = reponse.data.data ?? [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
            },
            async GetSalesAccountManagers() {
                try {
                    const reponse = await axios.get(`${this.url}/${apis.GetSalesAccountManagers}`);
                    this.samNames = reponse.data.data ?? [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
            },
            async GetAccounts() {
                try {
                    const reponse = await axios.get(`${this.url}/${apis.GetAccounts}`);
                    this.accounsts = reponse.data.data ?? [];
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
            },
            async Save() {
                const visitPurpose = this.visitPurposes.find((e) => e.visitPurposeName == this.form.visitPurpose)?.id;
                const region = this.regions.find((e) => e.regionName == this.form.region)?.id;
                const zone = this.zones.find((e) => e.zoneName == this.form.zone)?.id;
                const city = this.cities.find((e) => e.cityName == this.form.city)?.id;
                const accountType = this.accountTypes.find((e) => e.accountTypeName == this.form.accountType)?.id;
                const samId = this.samNames.find((e) => e.samName == this.form.samName)?.id;
                const accInfo = this.form.accountCode?.split('-');
                const files = this.fileList.map((f) => {
                    return {
                        Attachment: f?.dataUrl || null,
                        ContentType: f?.AttachmentType || null,
                        FileName: f?.fileObj?.name || f.fileObj.fileName,
                    };
                });
                const payload = {
                    id: this.form.visitId ? this.form.visitId : null,
                    VisitDate: this.form.visitDate,
                    SamId: samId,
                    VisitPurposeId: visitPurpose,
                    RegionId: region || null,
                    ZoneId: zone || null,
                    CityId: city,
                    MarketCatchment: this.form.marketCatchment,
                    AccountId: Number(accInfo[0]) || null,
                    AccountDealerName: this.form.dealerName,
                    AccountTypeId: accountType,
                    ContactPerson: this.form.contactPerson || null,
                    ContactRole: this.form.contactRole || null,
                    Mobile: this.form.mobile || null,
                    GpsLocationRef: this.form.gpsLocation || null,
                    EvidencePhotoRefs: files || null,
                    CreatedBy: this.form.createdBy || null,
                    Latitude: this.location.lat,
                    Longitude: this.location.lng,
                    Address: this.form.address || null,
                    srNo: this.form.srNo || 0
                };

                this.isSaving = true;

                try {
                    const response = await axios.post(`${this.url}/${apis.Save}`, payload);
                    if (response.data.success && response.data.validationState == 0) {
                        this.accessType = 'readOnly';
                        this.form = emptyForm();
                        this.$router.push('/visit-form-list');
                        this.activeStep = 0;
                    }
                    this.globalNotification(response.data.message, response.data.validationState);
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }

                this.isSaving = false;
            },

            async getVisistFormById(id) {
                this.activeStep = this.accessType == 'update' ? 0 : 2;
                this.isloading = true;
                try {
                    const response = await axios.post(`${this.url}/${apis.Get}?srNo=${id}`);
                    if (response.data.success) {
                        const { data } = response.data;
                        if (!data) return;
                        const samName = this.samNames.find((e) => e.id === data.samId);

                        const region = this.regions.find((e) => e.id === data.regionId);
                        const zone = this.zones.find((e) => e.id === data.zoneId);
                        const city = this.cities.find((e) => e.id === data.cityId);
                        const accountType = this.accountTypes.find((e) => e.id === data.accountTypeId);
                        const visitPurpos = this.visitPurposes.find((e) => e.id === data.visitPurposeId);
                        this.form = {
                            visitId: data.id,
                            visitDate:
                                this.accessType === 'update' ? this.$moment(data.visitDate)?.format('YYYY-MM-DD') : this.formatDate(data.visitDate),
                            samName: samName?.samName,
                            visitPurpose: visitPurpos?.visitPurposeName,
                            zone: zone?.zoneName,
                            region: region?.regionName,
                            city: city?.cityName,
                            accountCode: data.accountId + '-' + data.accountName,
                            accountType: accountType?.accountTypeName,
                            gpsLocation: data.gpsLocationRef,
                            marketCatchment: data.marketCatchment,
                            contactRole: data.contactRole,
                            contactPerson: data.contactPerson,
                            dealerName: data.accountDealerName,
                            mobile: data.mobile,
                            address: data.address,
                            editLocked: false,
                            createdWhen: data.createdAt,
                            serverDate: data.serverDate,
                            srNo: data.srNo
                        };

                        this.selectedLocation = {
                            lat: data.latitude,
                            lng: data.longitude,
                        };
                        this.locationSelected(this.selectedLocation);
                        this.fileList = data.evidencePhotoRefs.map((e) => {
                            return {
                                fileObj: e,
                                dataUrl: e.attachment,
                                AttachmentType: e.contentType,
                            };
                        });
                        this.startEditCountdown(data);
                    }
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    const newError = err.response || err;
                    console.error(newError);
                }
                this.keySelect += 1;

                this.isloading = false;
            },
            viewAttechment(att) {
                let string = `data:${att.AttachmentType};base64,${att.dataUrl}`;

                var iframe = "<iframe width='100%' height='100%' src='" + string + "'></iframe>";
                var x = window.open();
                x.document.open();
                x.document.write(iframe);
                x.document.close();
            },
            formatDate(date) {
                if (!date) return 'N/A';
                const value = String(date).substring(0, 10);
                const parts = value.split('-');
                if (parts.length !== 3) return value;
                return `${parts[2]}/${parts[1]}/${parts[0]}`;
            },

            deleteHandle(i) {
                if (this.accessType == 'readOnly') return;

                this.fileList.splice(i, 1);
            },

            async handleImagesUploading() {
                if (this.form.evidencePhoto?.length > 0) {
                    this.isFileUploading = true;

                    let fileList = [];

                    for (let fileObj of this.form.evidencePhoto) {
                        try {
                            const compressedBase64 = await this.readFileAsBase64(fileObj, 15000);
                            const resizedImage = compressedBase64.replace('data:', '').replace(/^.+,/, '');
                            if (!resizedImage) throw new Error('Empty compression result');
                            fileList.push({
                                fileObj,
                                dataUrl: resizedImage,
                                AttachmentType: fileObj.type,
                            });
                        } catch (err) {
                            this.$store.dispatch('triggerUnauthorizedError', err);
                            const newError = err.response || err;
                            console.error(newError);
                        }
                    }
                    this.fileList = this.fileList.length > 0 ? [...this.fileList, ...fileList] : fileList;
                }
            },
            readFileAsBase64(file, ms = 15000) {
                // return new Promise((resolve, reject) => {
                //     const reader = new FileReader();
                //     reader.onload = (e) => {
                //         resolve(e.target.result.replace('data:', '').replace(/^.+,/, ''));
                //     };
                //     reader.onerror = reject;
                //     reader.readAsDataURL(file);
                // });
                return Promise.race([
                    this.compressImage(file),
                    new Promise((_, reject) => setTimeout(() => reject(new Error('Compression timed out')), ms)),
                ]);
            },
            async compressImage(file) {
                return new Promise((resolve, reject) => {
                    const maxSize = 800;
                    const reader = new FileReader();

                    reader.onerror = (err) => {
                        console.error('FileReader failed', err);
                        reject(new Error('Failed to read file: ' + file.name));
                    };

                    reader.onload = (event) => {
                        const img = new Image();

                        img.onerror = (err) => {
                            console.error('Image load failed for', file.name, file.type, err);
                            reject(new Error(`Unsupported or corrupt image format: ${file.name}`));
                        };

                        img.onload = () => {
                            try {
                                const width = img.width;
                                const height = img.height;
                                let newWidth = width;
                                let newHeight = height;

                                if (width > maxSize || height > maxSize) {
                                    if (width > height) {
                                        newWidth = maxSize;
                                        newHeight = Math.floor((height / width) * maxSize);
                                    } else {
                                        newHeight = maxSize;
                                        newWidth = Math.floor((width / height) * maxSize);
                                    }
                                }

                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');
                                canvas.width = newWidth;
                                canvas.height = newHeight;
                                ctx.drawImage(img, 0, 0, newWidth, newHeight);

                                const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8);
                                resolve(compressedBase64);
                            } catch (error) {
                                console.error('Canvas processing failed', error);
                                reject(error);
                            }
                        };

                        img.src = event.target.result;
                    };

                    reader.readAsDataURL(file);
                });
            },
            showDrawer() {
                if (this.$refs.refDrawer) {
                    this.$refs.refDrawer.toggleDrawer();
                }
            },
            backStep() {
                this.activeStep = Math.max(this.activeStep - 1, 0);
            },
            // getCurrentLocation() {
            //     if (!navigator.geolocation) {
            //         this.$q.notify({
            //             type: 'negative',
            //             message: 'Location is not supported by this browser.',
            //         });
            //         return;
            //     }

            //     navigator.geolocation.getCurrentPosition(
            //         (position) => {
            //             const latitude = position.coords.latitude;
            //             const longitude = position.coords.longitude;

            //             this.latitude = latitude;
            //             this.longitude = longitude;
            //             this.gpsLocation = `${latitude},${longitude}`;

            //             console.log('Location:', this.gpsLocation);
            //         },

            //         (error) => {
            //             console.log('Location error:', error);

            //             switch (error.code) {
            //                 case error.PERMISSION_DENIED:
            //                     this.$q.notify({
            //                         type: 'warning',
            //                         message: 'Please allow location permission for this site.',
            //                     });
            //                     break;

            //                 case error.POSITION_UNAVAILABLE:
            //                     this.$q.notify({
            //                         type: 'warning',
            //                         message: 'Location information is unavailable.',
            //                     });
            //                     break;

            //                 case error.TIMEOUT:
            //                     this.$q.notify({
            //                         type: 'warning',
            //                         message: 'Location request timed out.',
            //                     });
            //                     break;
            //             }
            //         },

            //         {
            //             enableHighAccuracy: true,
            //             timeout: 15000,
            //             maximumAge: 0,
            //         }
            //     );
            // },
        },
    };
</script>

<style lang="scss" scoped>
@import '../../styles/quasar.scss';

.visit-page {
    min-height: 100vh;
    padding: 32px 16px;
    // background: #f2f7f8;
    position: relative;
    color: $primary;
    text-align: left;
}

.visit-shell {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
}

.visit-header {
    min-height: 162px;
    padding: 30px 34px;
    display: flex;
    align-items: flex-start;
    gap: 18px;
    color: $primary;
    background: #fff;
    border-radius: 20px 20px 0 0;
    margin-bottom: 2px;
    box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18) !important;
    position: relative;
}

.brand-mark,
.section-icon {
    display: grid;
    flex: 0 0 auto;
    place-items: center;
    border-radius: 12px;
}

.brand-mark {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.16);
}

.eyebrow {
    margin: 2px 0 5px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    opacity: 0.75;
}

h1 {
    margin: 0;
    font-size: 28px;
    line-height: 1.2;
    font-weight: 700;
}

.header-copy {
    margin: 7px 0 0;
    font-size: 14px;
    opacity: 0.85;
}

.header-status {
    margin-left: auto;
    padding: 8px 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 18px;
    font-size: 12px;
    white-space: nowrap;
}

.header-actions {
    position: absolute;
    top: 22px;
    right: 22px;
    margin: 0;
    display: flex;
    gap: 8px;
}

.drafts-link,
.logout-link {
    color: $primary;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 18px;
}

.progress-steps {
    padding: 18px 34px;
    display: flex;
    justify-content: space-around;
    background: #fff;
    border-bottom: 1px solid #e5edef;
}

.progress-step {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #91a1a5;
    font-weight: 600;
    font-size: 18px;
}

.progress-step span {
    width: 26px;
    height: 26px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #edf2f3;
    // margin-left: 10px;
    font-size: 18px;
}

.progress-step.active {
    color: $primary;
}

.progress-step.active span {
    color: #fff;
    background: $primary;
}

.progress-step.current small {
    font-weight: 700;
}

.form-card {
    padding: 32px 34px 28px;
    background: #fff;
}

.section-heading {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 28px;
}

.section-icon {
    width: 38px;
    height: 38px;
    color: $primary;
    background: #e7f2f4;
}

.section-heading h2 {
    margin: 0;
    font-size: 19px;
    color: $primary;
}

.section-heading p {
    margin: 3px 0 0;
    font-size: 13px;
    color: #73858a;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px 18px;
}

.form-grid :deep(.q-field__bottom) {
    padding-top: 4px;
    color: #778b90;
}

.form-grid :deep(.q-field--outlined .q-field__control:before) {
    border-color: #cbd9dc;
}

.form-grid :deep(.q-field--focused .q-field__control:after) {
    border-color: $primary;
}

.form-grid :deep(.q-field__label) {
    color: #778b90;
}

.form-grid :deep(.q-field__native) {
    color: rgba(0, 0, 0, 0.87);
}

.review-card {
    min-height: 390px;
}

.review-summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border: 1px solid #e0e9eb;
    border-radius: 12px;
    overflow: hidden;
}

.review-item {
    min-height: 70px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-bottom: 1px solid #e8eff0;
}

.review-item:nth-last-child(-n + 2) {
    border-bottom: 0;
}

.review-item:nth-child(odd) {
    border-right: 1px solid #e8eff0;
}

.review-item span {
    color: #789096;
    font-size: 12px;
}

.review-item strong {
    color: $primary;
    font-size: 14px;
    font-weight: 600;
}

.review-note {
    margin-top: 22px;
    color: #50676d;
    background: #f0f7f8;
    font-size: 13px;
}

.form-actions {
    padding: 18px 34px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border-top: 1px solid #e5edef;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 12px 28px rgba(27, 67, 77, 0.08);
}

.form-actions-mobile {
    padding: 18px 34px;
    display: flex;
    align-items: center;
    // justify-items: end;
    // width:100% !important;
    gap: 8px;
    background: #fff;
    border-top: 1px solid #e5edef;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 12px 28px rgba(27, 67, 77, 0.08);
}

.draft-button {
    color: $primary;
}

.primary-button {
    color: #fff;
    background: $primary-gradient;
    border-radius: 8px;
}

.primary-button-mobile {
    width: 100% !important;
    color: #fff;
    background: $primary-gradient;
    border-radius: 8px;
    padding: 5px;
    font-size: 18px;
}

@media (max-width: 641px) {
    .visit-page {
        padding: 0;
        position: relative;
    }

    .visit-header {
        min-height: 176px;
        padding: 24px 18px;
        border-radius: 0;
        flex-wrap: wrap;
        border-radius: 20px 20px 0 0;
        box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
        position: relative;
    }

    .header-status {
        margin-left: 66px;
        margin-top: -27px;
    }

    .visit-header {
        position: relative;
        padding-top: 70px;
        border-radius: 20px 20px 0 0;
        box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
    }

    .visit-header h1 {
        font-size: 18px;
    }

    .header-actions {
        // position: static;
        // margin-left: auto;
        // top: 22px;
        // right: 22px;
        position: absolute;
        top: 22px;
        right: 22px;
        margin: 0;
        display: flex;
        gap: 8px;
    }

    .fts-link,
    .logout-link {
        font-size: 11px;
    }

    .progress-steps {
        padding: 11px 13px;
        justify-content: space-between;
    }

    .progress-step {
        flex-direction: column;
        gap: 4px;
        align-items: center;
        font-size: 13px;
    }

    .progress-step small {
        font-size: 11px;
    }

    .progress-step span {
        width: 20px;
        height: 20px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        background: #edf2f3;
        // margin-left: 10px;
        font-size: 14px;
    }

    .form-card {
        padding: 25px 18px;
    }

    .form-grid,
    .review-summary {
        grid-template-columns: 1fr;
    }

    .review-item:nth-child(odd) {
        border-right: 0;
    }

    .review-item:nth-last-child(2) {
        border-bottom: 1px solid #e8eff0;
    }

    .review-item span {
        color: #789096;
        font-size: 15px;
    }

    .review-item strong {
        color: $primary;
        font-size: 18px;
        font-weight: 600;
    }

    .form-actions-mobile {
        padding: 16px 18px;
        width: 100%;
        display: flex;
        justify-content: end;
        border-radius: 0;
    }

    .draft-button {
        padding: 5px;
        font-size: 0;
    }

    .draft-button :deep(.q-btn__content) {
        font-size: 18px;
    }

    .formField {
        min-height: 60px;
    }

    .formField :deep(.q-field__control) {
        height: 60px;
        min-height: 60px;
    }

    .formField :deep(.q-field__native) {
        min-height: 60px;
    }

    .formField .q-item {
        min-height: 80px;
    }

    .formFieldMarket {
        min-height: 60px;
    }

    .gps-field {
        flex-direction: column;
    }

    .gps-field .gps-map-btn {
        width: 100%;
    }

    .gps-field .gps-input {
        width: 100% !important;
    }

    .section-icon {
        width: 42px;
        height: 42px;
        color: $primary;
        background: #e7f2f4;
    }

    .heading-section {
        flex: 1;
    }
}

@media (min-width: 800px) {
    .visit-shell {
        max-width: 100%;
    }
}

@media (min-width: 1024px) {
    .visit-shell {
        max-width: 80vw;
    }
}

.gps-field {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
}

.gps-input {
    flex: 1;
    min-width: 0;
}

.gps-map-btn {
    height: 40px;
    margin-top: 0;
    flex-shrink: 0;
}

.brand-logo-sera {
    height: 16px;
    margin-bottom: 10px;
}

.sub-heading {
    color: $magenta !important;
}
</style>